import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const OutOfOfficeIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M12.6667 2.66659H12V1.33325H10.6667V2.66659H5.33333V1.33325H4V2.66659H3.33333C2.6 2.66659 2 3.26659 2 3.99992V13.3333C2 14.0666 2.6 14.6666 3.33333 14.6666H12.6667C13.4 14.6666 14 14.0666 14 13.3333V3.99992C14 3.26659 13.4 2.66659 12.6667 2.66659ZM12.6667 13.3333H3.33333V6.66659H12.6667V13.3333ZM3.33333 5.33325V3.99992H12.6667V5.33325H3.33333ZM5.48667 11.6066L6.19333 12.3133L7.82 10.6866L9.44667 12.3133L10.1533 11.6066L8.52667 9.97992L10.1533 8.35325L9.44667 7.64659L7.82 9.27325L6.19333 7.64659L5.48667 8.35325L7.11333 9.97992L5.48667 11.6066Z" />
  </Icon>
);
export default memo(OutOfOfficeIcon);
